// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__ZFxdb","content":"RecentSearches_content__3JuDl"};